import { theme } from "../../theme";
export const reservationEdit = {
    wrapper: {
        display: "flex",
        justifyContent: "space-between",
    },
    contentWrapper: {
        height: "calc(100vh - 105px)",
        display: "flex",
        flexDirection: "column",
        // width: "74%", the width of the content part if we show the badge preview
        width: "100%",
    },
    topActions: {
        display: "flex",
        alignItems: "center",
        paddingBottom: "20px",
    },
    infoTitle: {
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
    },
    saveButton: {
        marginLeft: "20px",
        marginRight: "10px",
    },
    formContent: {
        position: "relative",
        width: "100%",
        flexGrow: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        overflow: "auto",
        "& .MuiFormControl-root": {
            my: 0.8,
        },
        "& .MuiInputBase-root": {
            m: 0,
        },
        "& .MuiFormHelperText-root ": {
            mx: 0,
        },
    },
    genericFields: {
        width: "50%",
        height: "100%",
        backgroundColor: theme.palette.grey[600],
        overflow: "auto",
        borderRadius: "5px",
    },
    formFields: {
        padding: "20px",
        textAlign: "left",
    },
    textFieldWithAdornment: {
        "& input": {
            paddingRight: "55px",
        },
    },
    attendeeThirdPartyId: {
        marginLeft: "5px", color: theme.palette.primary.main
    },
} as const;